var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"full-container"},[_c('el-header',{staticClass:"shadow"},[_c('admin-header')],1),_c('el-container',{staticClass:"main-container"},[_c('el-aside',{attrs:{"width":"232px"}},[_c('side',{ref:"side",staticClass:"side",attrs:{"list":_vm.userMenu}})],1),_c('el-main',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }